
export { default as FocusModeInfoDialog } from './FocusModeInfoDialog';
export { default as FocusModeSection } from './FocusModeSection';

/**
 * Props the Focus Mode explainer needs when opened. The web dialog carries its
 * own copy, so there is nothing to pass; the native one reuses the shared
 * AlertDialog and is given its strings here instead.
 */
export const FOCUS_MODE_INFO_DIALOG_PROPS = {};
